// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ris-slider-overlay {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 100;
  background: rgba(0, 0, 0, 0.7);
}
.ris-slider-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.ris-slider {
  display: flex;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #e0e0e0;
}
.ris-slide {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
}

.ris-slide-active {
  visibility: visible;
  opacity: 1;
  transition: visibility 0s ease-out 0.33s, opacity 2s ease-out;
}

.ris-slide-inactive {
  position: absolute;
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s ease-in 0.33s, opacity 2s ease-in;
}

.ris-slide-title-container {
  box-sizing: border-box;
  height: 12%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2% 4%;
}

.ris-slide-title {
  font-size: 1.8rem;
  color: #000000;
}

.ris-slide-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.ris-slide-image-container {
  box-sizing: border-box;
  width: 100%;
  padding: 2% 4%;
  height: 46%;
  position: relative;
}

.ris-slide-description-container {
  box-sizing: border-box;
  height: 18%;
  width: 100%;
  padding: 2% 4%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ris-slide-description {
  font-size: 1.6rem;
  text-align: center;
  color: #000000;
}

.ris-small {
  width: 30vw;
  height: 70vh;
}

.ris-medium {
  width: 40vw;
  height: 70vh;
}

.ris-large {
  width: 50vw;
  height: 70vh;
}

.ris-fullscreen {
  width: 100vw;
  height: 100vh;
}

.ris-controller-container {
  box-sizing: border-box;
  display: flex;
  width: 100%;
  position: relative;
  height: 24%;
  padding: 2% 4%;
  top: 76%;
}

.ris-controller-vertical {
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;
}

.ris-controller-horizontal {
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}

.ris-slide-icons-container {
  display: flex;
  justify-content: center;
  width: 100%;
}

.ris-bullet-active {
  background-color: rgba(0, 0, 0, 0.7);
}
.ris-bullet-inactive {
  background-color: #ffffff;
}

.ris-bullet {
  margin: 0 2%;
  display: inline-block;
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
}

.ris-control-button {
  color: white;
  background-color: rgba(0, 0, 0, 0.7);
  border: none;
  letter-spacing: 3px;
  border-radius: 5px;
}
.ris-control-button:hover {
  text-shadow: 0px 0px 3px rgba(255, 255, 255, 1);
  font-weight: 700;
  transition: all 0.3s ease 0s;
}

.ris-button-vertical {
  height: 30%;
  width: 100%;
}

.ris-button-horizontal {
  width: 30%;
  height: 30%;
}
`, "",{"version":3,"sources":["webpack://./node_modules/react-intro-slider/dist/styles.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,6DAA6D;AAC/D;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,2DAA2D;AAC7D;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;AACb","sourcesContent":[".ris-slider-overlay {\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100%;\n  z-index: 100;\n  background: rgba(0, 0, 0, 0.7);\n}\n.ris-slider-container {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n\n.ris-slider {\n  display: flex;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  background-color: #e0e0e0;\n}\n.ris-slide {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n}\n\n.ris-slide-active {\n  visibility: visible;\n  opacity: 1;\n  transition: visibility 0s ease-out 0.33s, opacity 2s ease-out;\n}\n\n.ris-slide-inactive {\n  position: absolute;\n  visibility: hidden;\n  opacity: 0;\n  transition: visibility 0s ease-in 0.33s, opacity 2s ease-in;\n}\n\n.ris-slide-title-container {\n  box-sizing: border-box;\n  height: 12%;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 2% 4%;\n}\n\n.ris-slide-title {\n  font-size: 1.8rem;\n  color: #000000;\n}\n\n.ris-slide-image {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.ris-slide-image-container {\n  box-sizing: border-box;\n  width: 100%;\n  padding: 2% 4%;\n  height: 46%;\n  position: relative;\n}\n\n.ris-slide-description-container {\n  box-sizing: border-box;\n  height: 18%;\n  width: 100%;\n  padding: 2% 4%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.ris-slide-description {\n  font-size: 1.6rem;\n  text-align: center;\n  color: #000000;\n}\n\n.ris-small {\n  width: 30vw;\n  height: 70vh;\n}\n\n.ris-medium {\n  width: 40vw;\n  height: 70vh;\n}\n\n.ris-large {\n  width: 50vw;\n  height: 70vh;\n}\n\n.ris-fullscreen {\n  width: 100vw;\n  height: 100vh;\n}\n\n.ris-controller-container {\n  box-sizing: border-box;\n  display: flex;\n  width: 100%;\n  position: relative;\n  height: 24%;\n  padding: 2% 4%;\n  top: 76%;\n}\n\n.ris-controller-vertical {\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: stretch;\n}\n\n.ris-controller-horizontal {\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n\n.ris-slide-icons-container {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n\n.ris-bullet-active {\n  background-color: rgba(0, 0, 0, 0.7);\n}\n.ris-bullet-inactive {\n  background-color: #ffffff;\n}\n\n.ris-bullet {\n  margin: 0 2%;\n  display: inline-block;\n  width: 1rem;\n  height: 1rem;\n  border-radius: 50%;\n}\n\n.ris-control-button {\n  color: white;\n  background-color: rgba(0, 0, 0, 0.7);\n  border: none;\n  letter-spacing: 3px;\n  border-radius: 5px;\n}\n.ris-control-button:hover {\n  text-shadow: 0px 0px 3px rgba(255, 255, 255, 1);\n  font-weight: 700;\n  transition: all 0.3s ease 0s;\n}\n\n.ris-button-vertical {\n  height: 30%;\n  width: 100%;\n}\n\n.ris-button-horizontal {\n  width: 30%;\n  height: 30%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
